var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"size":_vm.size,"hide-header":"","hide-footer":"","centered":"","no-close-on-backdrop":!_vm.closeOnBackdrop,"body-class":"m-3 text-primary"}},[_c('div',{attrs:{"id":"content"}},[_vm._t("title"),_vm._t("content"),_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }